import File from '@project2/components/file-transfer/file.vue'

// console.log(File);
//import FileTree from '@project2/components/file-transfer/FileTree.vue'
let lib = {
  config: {
    apiLogin: "apiLogin",
    loginFlag: true
  },
  cookie: {
    del(name) {
      let exp = new Date()
      exp.setTime(exp.getTime() - 1)
      var cval = this.get(name)
      if (cval != null) {
        document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
      }
    },
    set(name, value, time = 1000 * 60 * 60) {
      var exp = new Date()
      exp.setTime(exp.getTime() + time * 1)
      document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString()
    },
    get(name) {
      let arrStr = document.cookie.split("; ");
      for (let i = 0; i < arrStr.length; i++) {
        let temp = arrStr[i].split("=");
        if (temp[0] == name) return unescape(temp[1]);  //解码
      }
      return "";
    }
  },
  sessionStorage: {
    set: function (name, value) {
      var storage = window.sessionStorage;
      storage.setItem(name, value);
    },
    //显示数据
    get: function (name) {
      var storage = window.sessionStorage;
      return storage.getItem(name);
    }
  },
  errorCatch(data) {//need overwrite
    console.error(data)
  },
  generateRoutes(router, menus) {
    for (let menu of menus) {
      if (!menu.children && menu.clientPath && menu.frontClientComponent) {
        // let componentUrl = `${(menu.frontClientComponent.indexOf('file-transfer')>-1 || menu.frontClientComponent.indexOf('web-terminal')>-1 )?'@project2/components':'@/components'}/${menu.frontClientComponent}`
        if (menu.frontClientComponent.indexOf('file-transfer') > -1) {
          router.addRoute("Home", {
            path: menu.clientPath,
            name: menu.name,
            component: File,
            meta: {
              title: menu.title
            }
          })
        } else {
          router.addRoute("Home", {
            path: menu.clientPath,
            name: menu.name,
            component: (resolve) =>
              require([`@/components/${menu.frontClientComponent}`], resolve),
            meta: {
              title: menu.title
            }
          })
        }

      } else if (menu.children) {
        for (let subMenu of menu.children) {
          if (subMenu.clientPath && subMenu.frontClientComponent) {
            router.addRoute("Home", {
              path: subMenu.clientPath,
              name: subMenu.name,
              component: (resolve) =>
                require([
                  `@/components/${subMenu.frontClientComponent}`,
                ], resolve),
              meta: {
                title: subMenu.title,
              }
            })
          }
        }
      }
    }
  },
  formatTimer: function (value) {
    let date = new Date(value);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? "0" + MM : MM;
    let d = date.getDate();
    d = d < 10 ? "0" + d : d;
    let h = date.getHours();
    h = h < 10 ? "0" + h : h;
    let m = date.getMinutes();
    m = m < 10 ? "0" + m : m;
    let s = date.getSeconds();
    s = s < 10 ? "0" + s : s;
    return y + "-" + MM + "-" + d + " " + h + ":" + m;
  }
}
export {
  lib
}



// WEBPACK FOOTER //
// ./src/comm/assets/js/lib.js